module.exports = __webpack_public_path__ + "fefd22371c7742987e94f6d31d392d48.jpg";